module.exports = __webpack_public_path__ + "static/media/zarrar.4783840a.png";